/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { createContext, type ForwardedRef, forwardRef } from 'react';
import {
  type ContextValue,
  TooltipTrigger,
  useContextProps,
} from 'react-aria-components';
import { ProgressIndicator } from '../progress-indicator/progress-indicator.component';
import { Tag, type TagProps } from '../tag/tag.component';
import { Text } from '../text/text.component';
import { Tooltip } from '../tooltip/tooltip.component';

interface FilterListItemProps extends Omit<TagProps, 'children'> {
  children?: string;
  /** The category of the filter item, displayed in a tooltip. */
  category?: string;
  /** When true, replaces the text content with a loading spinner. */
  isPending?: boolean;
}

const FilterListItemContext = createContext<ContextValue<FilterListItemProps, HTMLDivElement>>({});

const FilterListItem = forwardRef((props: FilterListItemProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, FilterListItemContext);

  const { category, style, children, isPending, ...coreProps } = props;

  const tooltipContent = category
    ? (children?.length ?? 0) > 24 ? `${category}: ${children}` : category
    : undefined;

  return (
    <TooltipTrigger delay={300} isDisabled={!category}>
      <Tag ref={ref} variant="quaternary" style={style} {...coreProps}>
        {isPending ? <ProgressIndicator size={12} /> : <Text style={styles.text}>{children}</Text>}
      </Tag>
      <Tooltip placement="bottom">{tooltipContent}</Tooltip>
    </TooltipTrigger>
  );
});

const styles = stylex.create({
  text: {
    overflow: 'hidden',
    display: 'block',
    textOverflow: 'ellipsis',
    maxWidth: '24ch',
  },
});

export { FilterListItem, FilterListItemContext, type FilterListItemProps };
